import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// app imports
import Drawer from '../Drawer';
import Header from '../Header';
import { openDrawer } from 'store/reducers/menu';

export default function Menus() {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'));
  const dispatch = useDispatch();
  const { drawerOpen } = useSelector((state) => state.menu);

  // drawer toggler
  const [open, setOpen] = useState(drawerOpen);
  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  const handleDrawerOpen = () => {
    if (!open) {
      setOpen(true);
      dispatch(openDrawer({ drawerOpen: true }));
    }
  };

  const handleDrawerClose = () => {
    if (open) {
      setTimeout(() => {
        setOpen(false);
        dispatch(openDrawer({ drawerOpen: false }));
      }, 450);
    }
  };

  // useEffect(() => {
  //   // Set a timeout to change the state after 2 seconds
  //   const navTimeout = setTimeout(() => {
  //     setOpen(false);
  //     dispatch(openDrawer({ drawerOpen: false }));
  //   }, 1000);

  //   // Clean up the timeout to prevent memory leaks
  //   return () => clearTimeout(navTimeout);
  // }, []);

  // set media wise responsive drawer
  useEffect(() => {
    setOpen(!matchDownLG);
    dispatch(openDrawer({ drawerOpen: !matchDownLG }));
  }, [dispatch, matchDownLG]);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
  }, [drawerOpen]);

  return (
    <div id="menus">
      <Header open={open} handleDrawerToggle={handleDrawerToggle} />
      <Drawer
        open={open}
        handleDrawerToggle={handleDrawerToggle}
        handleDrawerOpen={handleDrawerOpen}
        handleDrawerClose={handleDrawerClose}
      />
    </div>
  );
}
